// @ts-nocheck
import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { curry, get, set, uniqueId } from 'lodash';

import { addItem } from '../utils';
import { emptyRequestLine, RequestLineFieldsFragment } from '../constants';
import { query, NAME as REQUEST_LINES_QUERY } from '../withCaseRequestLines';

const NAME = 'compositions_CaseRequestPanel_createCaseAgreementLine';

const mutation = gql`
  mutation ${NAME} ($caseId: ID!, $values: CaseLineAttrs!) {
    createCaseAgreementLine(
      input: {
        caseId: $caseId,
        agreementLine: $values
      }
    ) {
      requestAgreementLine {
        agreed
        agreementLine { ...RequestLineFields }
        requestLineId
      }
    }
  }
  ${RequestLineFieldsFragment}
`;

const buildMutationChild = curry((WrappedComponent, componentProps, mutate) => {
  const createRequestAgreementLine = (caseId, values = {}) => {
    if (!caseId) {
      const error = new Error(
        'createRequestAgreementLine requires the case id as first argument',
      );

      return Promise.reject(error);
    }

    return mutate({
      variables: { caseId, values },
      optimisticResponse: {
        createCaseAgreementLine: {
          __typename: 'CaseAgreementLinePayload',
          requestAgreementLine: {
            __typename: 'CaseAgreementLine',
            agreed: null,
            agreementLine: {
              __typename: 'CaseRequestLine',
              ...emptyRequestLine,
              id: uniqueId('temp_'),
            },
            requestLineId: null,
          },
        },
      },
      update: (store, { data }) => {
        const variables = { caseNumber: componentProps.caseNumber };
        const cache = store.readQuery({ query, variables });

        const lines = addItem(get(cache, 'case.agreementLines', []), {
          __typename: 'CaseAgreementLine',
          agreed: false,
          agreementLine: {
            __typename: 'CaseRequestLine',
            ...emptyRequestLine,
            ...get(
              data,
              'createCaseAgreementLine.requestAgreementLine.agreementLine',
            ),
          },
          requestLineId: null,
        });

        store.writeQuery({
          query,
          data: set(cache, 'case.agreementLines', lines),
          variables,
        });
      },
    });
  };

  return (
    <WrappedComponent
      {...componentProps}
      createRequestAgreementLine={createRequestAgreementLine}
    />
  );
});

const withCreateRequestAgreementLine = WrappedComponent => componentProps => (
  <Mutation mutation={mutation} refetchQueries={[REQUEST_LINES_QUERY]}>
    {buildMutationChild(WrappedComponent, componentProps)}
  </Mutation>
);

export default withCreateRequestAgreementLine;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestAgreementLinesActions/withCreateCaseAgreementLine.js